import { createPuzzleProgressStore } from "../shared-sortaballs/puzzle-progress"

export type { PuzzleProgress } from "../shared-sortaballs/puzzle-progress"

export const { checkIfSolved, getPuzzleProgress, loadProgress, saveProgress } =
	createPuzzleProgressStore("sortaballs-8-colors-puzzle-progress")